import { LocalStorage, SessionStorage } from '@hotjar/insights-common/lib/storage-factory';
import { mark, measureAndLog } from '@hotjar/performance';
import { isAllowed } from '@hotjar/webapp/domains/common/feature';
import { getState } from '@hotjar/webapp/domains/activation/tracking-code';
import * as recordingsWidget from '@hotjar/webapp/features/Activation/hooks/useRecordingsWidget';
import { MARKS } from '@hotjar/webapp/performance';
import { getSegments } from './getSegments';
import { getSite } from './getSite';

import type { Store } from '../../../store/list/types';

/**
 * Initialize scope variables
 */
export const initialize = async (store: Store): Promise<void> => {
  const { columns, setColumns, setTrackingCode } = store.getState();

  mark(MARKS.RECORDINGS_LIST_SITE_FETCH_START);
  const site = getSite(store);

  // Perf: Measure how long it took to fetch the site
  measureAndLog({
    name: MARKS.RECORDINGS_LIST_SITE_FETCH_TIME,
    startMark: MARKS.RECORDINGS_LIST_SITE_FETCH_START,
  });

  const hasAccessToReferrerURL = isAllowed('filters.referrer_url', site);
  setColumns({
    ...columns,
    referrer_url: {
      ...columns.referrer_url,
      label: 'Referrer URL',
      show: hasAccessToReferrerURL,
      isDisabled: !hasAccessToReferrerURL,
      showInPanel: true,
    },
  });

  setTrackingCode(getState(site.lastData));

  // clear query cache on recordings widget component
  recordingsWidget.clearRecordingsWidgetData(site.id);

  cleanUpStoresFromSurveryPromptExperimentData();

  getSegments(store);
};

/*
    TODO: RECS-720
    The `ft_surveys_in_recording_list` experiment was setting
    few data in the local and session storage.
    This function cleans up the stores from those values and
    it has to be removed in the near future.
*/
function cleanUpStoresFromSurveryPromptExperimentData() {
  if (LocalStorage.get('playbacksSurveyPromptDismissed') !== null) {
    LocalStorage.remove('playbacksSurveyPromptDismissed');
  }

  if (LocalStorage.get('playbacksSurveyPromptInVariant') !== null) {
    LocalStorage.remove('playbacksSurveyPromptInVariant');
  }

  if (SessionStorage.get('playbacksSurveyPromptPostponed') !== null) {
    SessionStorage.remove('playbacksSurveyPromptPostponed');
  }
}
